export default __webpack_public_path__ + "static/media/team1.a257169c.png";